const PodiumIcon = () => {
  return (
    <svg
      width="234"
      height="88"
      viewBox="0 0 234 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="podium"
    >
      <g opacity="0.4">
        <path
          d="M36.2981 26.6663C36.4495 26.5854 36.6186 26.5431 36.7903 26.5434L67.4098 26.5924C67.5893 26.5927 67.7656 26.6394 67.9216 26.7279L78.1296 32.523H25.3496L36.2981 26.6663Z"
          fill="#BDC0C6"
        />
        <g filter="url(#filter0_d_10026_44817)">
          <path
            d="M25.3496 32.5234H78.1296V74.1234C78.1296 74.6978 77.664 75.1634 77.0896 75.1634H26.3896C25.8152 75.1634 25.3496 74.6978 25.3496 74.1234V32.5234Z"
            fill="url(#paint0_linear_10026_44817)"
          />
          <g filter="url(#filter1_d_10026_44817)">
            <rect
              x="44.46"
              y="46.5625"
              width="14.56"
              height="14.56"
              rx="1.04"
              fill="#798092"
              shapeRendering="crispEdges"
            />
            <path
              d="M48.6081 56.3438V55.6524L50.2235 54.1566C50.3609 54.0237 50.4761 53.904 50.5692 53.7977C50.6637 53.6913 50.7353 53.5872 50.7841 53.4852C50.8328 53.3818 50.8572 53.2703 50.8572 53.1506C50.8572 53.0177 50.8269 52.9032 50.7664 52.8072C50.7058 52.7097 50.6231 52.6351 50.5182 52.5834C50.4133 52.5302 50.2944 52.5036 50.1614 52.5036C50.0226 52.5036 49.9014 52.5316 49.798 52.5878C49.6946 52.6439 49.6148 52.7244 49.5587 52.8293C49.5026 52.9342 49.4745 53.059 49.4745 53.2038H48.5638C48.5638 52.9069 48.631 52.6491 48.7654 52.4305C48.8998 52.2118 49.0882 52.0427 49.3305 51.923C49.5727 51.8034 49.8519 51.7435 50.1681 51.7435C50.4931 51.7435 50.776 51.8011 51.0168 51.9164C51.259 52.0301 51.4474 52.1882 51.5818 52.3906C51.7163 52.593 51.7835 52.8249 51.7835 53.0864C51.7835 53.2577 51.7495 53.4269 51.6815 53.5938C51.6151 53.7607 51.4961 53.9461 51.3248 54.15C51.1534 54.3524 50.9119 54.5954 50.6002 54.879L49.9376 55.5283V55.5593H51.8433V56.3438H48.6081ZM52.5962 53.1617V52.9268C52.5962 52.7156 52.6405 52.5287 52.7291 52.3662C52.8177 52.2022 52.9433 52.0737 53.1058 51.9806C53.2698 51.8876 53.4618 51.841 53.682 51.841C54.0188 51.841 54.2839 51.943 54.4775 52.1468C54.6725 52.3507 54.77 52.6107 54.77 52.9268V53.1617C54.77 53.3715 54.7264 53.5576 54.6392 53.7201C54.5521 53.8811 54.428 54.0082 54.267 54.1013C54.1059 54.1928 53.9139 54.2386 53.6908 54.2386C53.3525 54.2386 53.0851 54.1382 52.8887 53.9373C52.6937 53.7349 52.5962 53.4764 52.5962 53.1617ZM53.1435 52.9268V53.1617C53.1435 53.3434 53.1893 53.4941 53.2809 53.6138C53.3725 53.7319 53.5091 53.791 53.6908 53.791C53.8696 53.791 54.0025 53.7319 54.0897 53.6138C54.1783 53.4941 54.2226 53.3434 54.2226 53.1617V52.9268C54.2226 52.7495 54.1783 52.5996 54.0897 52.477C54.001 52.3544 53.8651 52.2931 53.682 52.2931C53.5047 52.2931 53.3702 52.3544 53.2787 52.477C53.1885 52.5996 53.1435 52.7495 53.1435 52.9268Z"
              fill="white"
            />
          </g>
        </g>
        <path
          d="M101.789 6.52344L132.944 6.57327L143.39 12.5034H90.6104L101.789 6.52344Z"
          fill="#FFD84E"
        />
        <g filter="url(#filter2_d_10026_44817)">
          <path
            d="M90.6104 12.5039H143.39V74.1239C143.39 74.6983 142.925 75.1639 142.35 75.1639H91.6504C91.076 75.1639 90.6104 74.6983 90.6104 74.1239V12.5039Z"
            fill="url(#paint1_linear_10026_44817)"
          />
          <g filter="url(#filter3_d_10026_44817)">
            <rect
              x="108.16"
              y="34.8633"
              width="17.68"
              height="17.68"
              rx="1.04"
              fill="#DBAB00"
              shapeRendering="crispEdges"
            />
            <path
              d="M115.623 40.6522V46.7031H114.344V41.8665H114.308L112.922 42.7352V41.6006L114.42 40.6522H115.623ZM117.138 42.4604V42.1472C117.138 41.8655 117.197 41.6164 117.315 41.3997C117.433 41.1811 117.601 41.0097 117.817 40.8856C118.036 40.7615 118.292 40.6995 118.586 40.6995C119.035 40.6995 119.388 40.8354 119.646 41.1072C119.906 41.379 120.036 41.7257 120.036 42.1472V42.4604C120.036 42.7401 119.978 42.9883 119.862 43.2049C119.746 43.4196 119.58 43.589 119.366 43.7131C119.151 43.8352 118.895 43.8963 118.597 43.8963C118.146 43.8963 117.79 43.7624 117.528 43.4945C117.268 43.2246 117.138 42.8799 117.138 42.4604ZM117.868 42.1472V42.4604C117.868 42.7027 117.929 42.9036 118.051 43.0631C118.173 43.2207 118.355 43.2995 118.597 43.2995C118.836 43.2995 119.013 43.2207 119.129 43.0631C119.247 42.9036 119.307 42.7027 119.307 42.4604V42.1472C119.307 41.9109 119.247 41.7109 119.129 41.5474C119.011 41.384 118.83 41.3022 118.586 41.3022C118.349 41.3022 118.17 41.384 118.048 41.5474C117.928 41.7109 117.868 41.9109 117.868 42.1472Z"
              fill="white"
            />
          </g>
        </g>
        <path
          d="M167.049 44.4844L198.204 44.5342L208.65 50.4644H155.87L167.049 44.4844Z"
          fill="#FFA23D"
        />
        <g filter="url(#filter4_d_10026_44817)">
          <path
            d="M155.87 50.4648H208.65V74.1248C208.65 74.6992 208.184 75.1648 207.61 75.1648H156.91C156.336 75.1648 155.87 74.6992 155.87 74.1248V50.4648Z"
            fill="url(#paint2_linear_10026_44817)"
          />
          <g filter="url(#filter5_d_10026_44817)">
            <rect
              x="176.28"
              y="56.7148"
              width="12.22"
              height="12.2"
              rx="1.04"
              fill="#B0630E"
              shapeRendering="crispEdges"
            />
            <path
              d="M180.925 64.3629C180.676 64.3629 180.455 64.3203 180.261 64.235C180.069 64.1486 179.916 64.03 179.804 63.8793C179.694 63.7275 179.637 63.5525 179.633 63.3541H180.358C180.362 63.4372 180.389 63.5104 180.439 63.5735C180.49 63.6356 180.558 63.6838 180.642 63.7181C180.726 63.7525 180.821 63.7696 180.926 63.7696C181.036 63.7696 181.133 63.7502 181.217 63.7115C181.301 63.6727 181.367 63.6189 181.415 63.5503C181.463 63.4816 181.486 63.4023 181.486 63.3126C181.486 63.2217 181.461 63.1414 181.41 63.0716C181.36 63.0007 181.288 62.9453 181.194 62.9054C181.101 62.8655 180.99 62.8456 180.861 62.8456H180.544V62.3171H180.861C180.97 62.3171 181.066 62.2983 181.149 62.2606C181.233 62.2229 181.299 62.1709 181.345 62.1044C181.392 62.0368 181.415 61.9581 181.415 61.8684C181.415 61.7831 181.394 61.7083 181.353 61.644C181.313 61.5787 181.257 61.5277 181.184 61.4911C181.112 61.4546 181.028 61.4363 180.931 61.4363C180.834 61.4363 180.745 61.454 180.664 61.4895C180.583 61.5238 180.518 61.5731 180.469 61.6374C180.42 61.7016 180.394 61.777 180.391 61.8634H179.701C179.705 61.6673 179.761 61.4944 179.869 61.3449C179.978 61.1953 180.124 61.0784 180.308 60.9942C180.493 60.9089 180.702 60.8662 180.935 60.8662C181.169 60.8662 181.375 60.9089 181.551 60.9942C181.727 61.0795 181.864 61.1947 181.962 61.3399C182.06 61.4839 182.109 61.6457 182.108 61.8252C182.109 62.0157 182.05 62.1747 181.93 62.3021C181.812 62.4296 181.657 62.5104 181.466 62.5448V62.5714C181.717 62.6035 181.907 62.6905 182.038 62.8323C182.17 62.973 182.235 63.1492 182.234 63.3608C182.235 63.5547 182.179 63.727 182.066 63.8777C181.954 64.0283 181.8 64.1469 181.603 64.2333C181.405 64.3197 181.179 64.3629 180.925 64.3629ZM182.795 61.9299V61.7537C182.795 61.5953 182.828 61.4551 182.894 61.3332C182.961 61.2103 183.055 61.1139 183.177 61.0441C183.3 60.9743 183.444 60.9394 183.609 60.9394C183.862 60.9394 184.061 61.0158 184.206 61.1687C184.352 61.3216 184.425 61.5166 184.425 61.7537V61.9299C184.425 62.0872 184.392 62.2268 184.327 62.3487C184.262 62.4694 184.169 62.5647 184.048 62.6345C183.927 62.7032 183.783 62.7376 183.616 62.7376C183.362 62.7376 183.161 62.6622 183.014 62.5115C182.868 62.3598 182.795 62.1659 182.795 61.9299ZM183.205 61.7537V61.9299C183.205 62.0662 183.24 62.1792 183.308 62.2689C183.377 62.3575 183.479 62.4019 183.616 62.4019C183.75 62.4019 183.849 62.3575 183.915 62.2689C183.981 62.1792 184.015 62.0662 184.015 61.9299V61.7537C184.015 61.6208 183.981 61.5083 183.915 61.4163C183.848 61.3244 183.746 61.2784 183.609 61.2784C183.476 61.2784 183.375 61.3244 183.307 61.4163C183.239 61.5083 183.205 61.6208 183.205 61.7537Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_10026_44817"
          x="12.8696"
          y="20.0434"
          width="77.7403"
          height="67.6006"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.580392 0 0 0 0 0.611765 0 0 0 0 0.686275 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_10026_44817"
          x="31.98"
          y="34.0825"
          width="39.5196"
          height="39.5186"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_10026_44817"
          x="78.1304"
          y="0.0239067"
          width="77.7403"
          height="87.6202"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.976471 0 0 0 0 0.784314 0 0 0 0 0.101961 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_10026_44817"
          x="95.6802"
          y="22.3833"
          width="42.6397"
          height="42.6397"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_10026_44817"
          x="143.39"
          y="37.9848"
          width="77.7403"
          height="49.6592"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.760784 0 0 0 0 0.411765 0 0 0 0 0.0235294 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_10026_44817"
          x="163.8"
          y="44.2348"
          width="37.1797"
          height="37.1592"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.24" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10026_44817"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10026_44817"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10026_44817"
          x1="25.4669"
          y1="32.5234"
          x2="84.9247"
          y2="61.4259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0A7BA" />
          <stop offset="1" stopColor="#747C8E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10026_44817"
          x1="90.7276"
          y1="12.5039"
          x2="156.633"
          y2="54.6295"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCE20" />
          <stop offset="1" stopColor="#DDAC00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10026_44817"
          x1="155.987"
          y1="50.4648"
          x2="210.296"
          y2="71.1529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DA770B" />
          <stop offset="1" stopColor="#B45F01" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PodiumIcon;
